import React, { useEffect, useState }       from 'react';
import ResiFormLayout                       from '../../../components/ResiFormLayout';
import CustomTextFieldAggiungi              from '../../../components/fields/CustomTextFieldAggiungi';
import CustomNoteAggiungi                   from '../../../components/fields/CustomNoteAggiungi';
import CustomDragAndDrop                    from '../../../components/fields/CustomDragAndDrop';
import MerceDanneggiata                     from '../../../images/MerceDanneggiataPng.png';
import { useNavigate }                      from 'react-router-dom';
import CustomDatePickerAggiungi             from '../../../components/fields/CustomDatePickerAggiungi';
import axios                                from 'axios';
import CustomAutocomplete                   from '../../../components/fields/CustomAutocomplete';
import { useTranslation }                   from 'react-i18next';
import SendEmail                            from '../../../components/SendEmail';
import SendAvviso                           from '../../../components/SendAvviso';
import dayjs                                from 'dayjs';
import CircularProgressWithLabel            from '../../../components/CircularProgressWithLabel';
import AddCircleIcon                        from "@mui/icons-material/AddCircle";
import RemoveCircleIcon                     from "@mui/icons-material/RemoveCircle";
import { 
    Grid, 
    Button, 
    Box, 
    Typography,
    Switch, 
    Alert, 
    IconButton,
    TextField
} from '@mui/material';
import CustomNumber2 from '../../../components/fields/CustomNumber2';
import ApiService from '../../../components/service/ApiService';
import CustomNumberAggiunta from '../../../components/fields/CustomNumberAggiunta';


const MerceDanneggiataForm = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const [alert,                       setAlert                    ] = useState({ open: false, message: '', severity: 'success' });
    const [errors,                      setErrors                   ] = useState({});
    const [message,                     setMessage                  ] = useState('');
    const [loading,                     setLoading                  ] = useState(false);
    const [progress,                    setProgress                 ] = useState(0);
    const [fattureOptions,              setFattureOptions           ] = useState([]);
    const [skuOptions,                  setSkuOptions               ] = useState([]);
    const [skuDetails,                  setSkuDetails               ] = useState([]);
    const [dataFattura,                 setDataFattura              ] = useState([]);
    const [isDataRicezioneEnabled,      setIsDataRicezioneEnabled   ] = useState(false);
    const [maxQty,                      setMaxQty                   ] = useState(1);  
    const [merceFirmataRiserva,         setMerceFirmataRiserva      ] = useState(null);
    const [uploadedRiservaFiles,        setUploadedRiservaFiles     ] = useState([]);
    const [isFatturaSelected,           setIsFatturaSelected        ] = useState(false);
    const [isFetchingFatturaDetails,    setIsFetchingFatturaDetails ] = useState(false);
    const [isSkuSelected,               setIsSkuSelected            ] = useState(false);


    const [products,            setProducts         ] = useState([
        { skuEan: '', descrizione: '', quantita: '', imeiSerial: null }
    ]);    
    
    const [snackbarSeverity,    setSnackbarSeverity ] = useState('success');
    const [formValues,          setFormValues       ] = useState({
        tipologia: 'ANOMALIA_MERCE_DANNEGGIATA',
        numeroFattura: '',
        compagniaTrasporto: '',
        infoAggiuntive: '',
        quantita: '1',
        skuEan: '',
        dataCreazioneRMA: dayjs().format('DD/MM/YYYY'),
        richiestaIndirizzo: false,
        imeiSerial: null,
        infoProblema: null,
        descrizione: '',
        dataFattura: null,
        dataRicezione: null,
        stato: null,
        id: null,
        dannoFisico: null,
        idReso: null,
        numeroFatturaClienteFinale: null,
        merceFirmataRiserva: null,
        dataRicezioneMerce: '',
        dataFatturaClienteFinale: null,
        possessoResocontoTecnico: null,
        merceDifferente: null,
        prodotti: [{ skuEan: '', descrizione: '', quantita: '', imeiSerial: null }]
    });
    const [uploadedFiles, setUploadedFiles] = useState({
        fotoProdotto:   [],
        fotoScatola:    [],
    }); const [step, setStep] = useState(1);

    const user = JSON.parse(sessionStorage.getItem("user"));
    const token = user?.token;
    const headers = {
        Authorization: `Bearer ${token}`
    };
    const idCliente = user?.idCliente;  
    const ragioneSociale = user?.ragioneSociale;
    const id = user?.IDCustomerRMT;
    const IDCustomerRMT = user?.idRiba;




const fetchFatture = async () => {
    setLoading(true);
    try {
        // const response = await axios.get(`http://localhost:8080/cliente/riba/fatture/${id}`, { headers: headers });
        const response = await ApiService.request("getFatture", { id: id});
        
        // if (response.data?.code === 200 && Array.isArray(response.data.result)) {
            // const fattureOptions = response.data.result.map((fattura) => {
            //     const formattedDate = dayjs(fattura.DateInvoice, "YYYYMMDD").format("DD/MM/YYYY");
                
            //     return {
            //         label: `${fattura.InvoiceNr} - ${formattedDate}`,
            //         value: fattura.InternalIDInvoice, 
            //     };
            // }).reverse();
            if (response.data?.code === 200 && Array.isArray(response.data.result)) {
                const today = dayjs(); 
                const oneMonthAgo = today.subtract(1, "month"); 
                
                const fattureOptions = response.data.result
                    .filter((fattura) => {
                        const fatturaDate = dayjs(fattura.DateInvoice, "YYYYMMDD");
                        return fatturaDate.isAfter(oneMonthAgo);
                    })
                    .map((fattura) => {
                        const formattedDate = dayjs(fattura.DateInvoice, "YYYYMMDD").format("DD/MM/YYYY");
                        return {
                            label: `${fattura.InvoiceNr} - ${formattedDate}`,
                            value: fattura.InternalIDInvoice, 
                        };
                    })
                    .reverse();
            
            setFattureOptions(fattureOptions);
        } else {
            console.error("La risposta non contiene un array valido in `result`:", response.data);
        }
    } catch (error) {
        console.error("Errore durante il fetch delle fatture!", error);
    } finally {
        setLoading(false);
    }
};

useEffect(() => {
        fetchFatture();
    }, []);

    useEffect(() => {
        let timer;
    
        if (loading) {
            setProgress(0); 
                timer = setInterval(() => {
                setProgress((prevProgress) => {
                    if (prevProgress >= 100) {
                    clearInterval(timer); 
                    setLoading(false); 
                    return 100;
                    }
                return prevProgress + 10; 
                });
            }, 300); 
        }
    
        return () => clearInterval(timer);
    }, [loading]);

    useEffect(() => {
        if (maxQty !== null) {
            setProducts((prevProducts) =>
                prevProducts.map((product) => ({
                    ...product,
                    quantita: Math.min(product.quantita, maxQty).toString(), 
                }))
            );
        }
    }, [maxQty]);
    


    const handleInputChange = (input) => {
        setFormValues({
            ...formValues,
            ...input,
        });
        setErrors({
            ...errors,
            ...Object.keys(input).reduce((acc, key) => {
                if (input[key] === '') {
                    acc[key] = 'Questo campo è obbligatorio';
                } else {
                    delete errors[key];
                }
                return acc;
            }, {}),
        });
    };



    const handleDateChange = (input) => {
        const selectedDate = dayjs(input.dataRicezioneMerce, "DD/MM/YYYY");
        const invoiceDate = dayjs(formValues.dataFattura, "DD/MM/YYYY");
        const diffDays = selectedDate.diff(invoiceDate, 'day');
        const limiteGiorni = ["Schenker", "TSB"].includes(formValues.compagniaTrasporto) ? 5 : 7;
        if (diffDays > limiteGiorni) {
        setAlert({
            open: true,
            message: t("Non possiamo elaborare la vostra richiesta. Come indicato nei nostri termini e condizioni, possiamo accettare richieste fino a 7 giorni dalla ricezione merce."),
            severity: "error",
        });
        setFormValues((prevValues) => ({
            ...prevValues,
            dataRicezioneMerce: null, 
        }));
        setIsDataRicezioneEnabled(false);
            return; 
        }

        setFormValues((prevValues) => ({
            ...prevValues,
            dataRicezioneMerce: input.dataRicezioneMerce,
        }));
    };
    


    const handleFilesAdded = (key, files) => {
        setUploadedFiles((prevFiles) => ({
            ...prevFiles,
            [key]: files,
        }));
    };


    //funzione per la validazione dei campi
    const validateFields = (values, mandatoryFields) => {
        let errors = {};
        mandatoryFields.forEach((field) => {
            if (!values[field]) {
                errors[field] = t("Questo campo è obbligatorio");
            }
        });
        // if (!products.some(product => product.skuEan && product.descrizione && product.quantita)) {
        //     errors["products"] = t("Devi compilare almeno un prodotto con SKU, descrizione e quantità.");
        // }
        // if (values.quantita > maxQty) {
        //     errors['quantita'] = t(`La quantità non può superare ${maxQty} pezzi.`);
        // }

        if (!values.prodotti || values.prodotti.length === 0) {
            errors["prodotti"] = t("Devi aggiungere almeno un prodotto.");
        }

        if (!values.prodotti.every((product) => product.skuEan && product.descrizione && product.quantita)) {
            errors["prodotti"] = t("Ogni prodotto deve avere SKU, descrizione e quantità.");
        }
        if (["Schenker", "Redur", "TSB", "Altro"].includes(values.compagniaTrasporto)) {
            if (merceFirmataRiserva === null) {
                errors["firmaRiserva"] = t("Seleziona una risposta per: La merce è stata firmata con riserva?");
            }
            if (merceFirmataRiserva === "si" && uploadedRiservaFiles.length === 0) {
                errors["uploadRiserva"] = t("Devi allegare il documento firmato con riserva.");
            }
        }
        return errors;
    };


    const handleResetFileNames = (switchKey) => {
        setUploadedFiles((prevFiles) => ({
            ...prevFiles,
            [switchKey]: [],
        }));
    };

    const campiObbligatori = ["numeroFattura", "compagniaTrasporto", "dataRicezioneMerce"];

    // const handleNextClick = () => {
    //     const validationErrors = validateFields(formValues, campiObbligatori);
    //     if (Object.keys(validationErrors).length === 0) {
    //         setStep(2);
    //     } else {
    //         setErrors(validationErrors);
    //     }
    // };

    const handleNextClick = () => {
    const validationErrors = validateFields(formValues, campiObbligatori);

    const hasInvalidQuantita = !formValues.prodotti.every(p => p.quantita && !isNaN(p.quantita) && parseInt(p.quantita, 10) > 0);

    if (hasInvalidQuantita) {
        setAlert({
            open: true,
            message: t("Ogni prodotto deve avere una quantità valida (maggiore di zero)."),
            severity: "error"
        });
        return;
    }

    if (Object.keys(validationErrors).length === 0) {
        setStep(2);
    } else {
        setErrors(validationErrors);
    }
};



    const fields = [
        { label: t('Numero della fattura'),            name: 'numeroFattura',              type: 'select', options: fattureOptions     , disabled: false             },
        { label: t('Compagnia di trasporto'),          name: 'compagniaTrasporto',         type: 'text'                                , disabled: true              },
        { label: t('Data ricezione merce'),            name: 'dataRicezioneMerce',         type: 'date'                                , disabled: !isFatturaSelected},
        // { label: t('SKU/EAN del prodotto'),            name: 'skuEan',                     type: 'select', options: skuOptions         , disabled: !isFatturaSelected},
        // { label: t('Quantità'),                        name: 'quantita',                   type: 'number', maxLength: 20               , disabled: !isFatturaSelected},
        // { label: t('Descrizione del prodotto'),        name: 'descrizione',                type: 'note',   multiline: true, rows: 4    , disabled: true              },
        { label: t('Info aggiuntive'),                 name: 'infoAggiuntive',             type: 'note',   multiline: true, rows: 4    , disabled: !isFatturaSelected}
    ];


    const productFields = [
        {
            label: t('SKU/EAN del prodotto'),
            name: 'skuEan',
            type: 'select',
            options: skuOptions,
            disabled: !isFatturaSelected,
        },
        {
            label: t('Quantità'),
            name: 'quantita',
            type: 'number',
            maxLength: 20,
            disabled: !isFatturaSelected || isFetchingFatturaDetails,
        },
        {
            label: t('Descrizione del prodotto'),
            name: 'descrizione',
            type: 'note',
            multiline: true,
            rows: 4,
            disabled: true,
        },
    ];
    

    // const handleFatturaChange = async (fieldValue) => {
    //     const numeroFattura = fieldValue.numeroFattura;

    //     if (!numeroFattura) {
    //         setFormValues((prevValues) => ({
    //             ...prevValues,
    //             numeroFattura: '',
    //             dataFattura: null, 
    //             numeroFatturaReal: null,
    //         }));
    //         setIsDataRicezioneEnabled(false); 
    //         setSkuOptions([]); 
    //         return;
    //     }
    //     setIsFatturaSelected(!!numeroFattura);
    //     setLoading(true);
    //     setIsFetchingFatturaDetails(true);

    //     const selectedFattura = fattureOptions.find(
    //         (fattura) => fattura.value === numeroFattura
    //     );
    
    //     if (selectedFattura) {
    //         const dataFatturaEstratta = selectedFattura.label.split(" - ")[1]; 

    //         setFormValues((prevValues) => ({
    //             ...prevValues,
    //             numeroFattura: numeroFattura,
    //             dataFattura: dataFatturaEstratta, 
    //             numeroFatturaReal: selectedFattura.label.split(" - ")[0],
    //         }));

    //         setDataFattura(dataFatturaEstratta);
    //         setIsDataRicezioneEnabled(true);
    //     }
        


    //     try {
    //         const response = await axios.get(
    //             `http://localhost:8080/cliente/riba/dati/fattura/${numeroFattura}`,
    //             { headers: headers }
    //         );
    
    //         if (response.data?.code === 200 && Array.isArray(response.data.result)) {
    //             const fatturaDettagli = response.data.result; 
    //             setSkuDetails(fatturaDettagli);
    //             const skuOptions = fatturaDettagli.map((item) => ({
    //                 label: item.SKU, 
    //                 value: item.SKU,
    //             }));

    //             setSkuOptions(skuOptions);
    //             const firstItem = fatturaDettagli[0];
    //             const deliveryDateFormatted = dayjs(firstItem.DeliveryDate, "YYYYMMDD").format("DD/MM/YYYY");
    //             setFormValues((prevValues) => ({
    //                 ...prevValues,
    //                 dataFattura: deliveryDateFormatted,
    //                 compagniaTrasporto: firstItem.Courier || null,
    //                 dataRicezioneMerce: deliveryDateFormatted
    //             }));
    //             const corriere = firstItem.Courier || null;
    //             const compagnieRichiedonoRiserva = ["Schenker", "Redur", "TSB", "Altro"];
    //             if (compagnieRichiedonoRiserva.includes(corriere)) {
    //                 setMerceFirmataRiserva(null); 
    //             } else {
    //                 setMerceFirmataRiserva(null); 
    //             }
    //         } else {
    //             console.error("La risposta non contiene un array valido in `result`:", response.data);
    //         }
    //     } catch (error) {
    //         console.error("Errore durante il fetch dei dettagli della fattura!", error);
    //     } finally {
    //         setLoading(false);
    //         setIsFetchingFatturaDetails(false);
    //     }
    // };


    const getDatePickerState = () => {
        const today = dayjs();
        const dataFatturaDayjs = formValues.dataFattura ? dayjs(formValues.dataFattura, "DD/MM/YYYY") : null;
    
        // Caso 1: Data fattura non valida (vuota, null, undefined, "0")
        if (!dataFatturaDayjs || formValues.dataFattura === "0") {
            return { disabled: false, value: "" };
        }
    
        const diffDays = today.diff(dataFatturaDayjs, "day");
        const limiteGiorni = ["Schenker", "TSB"].includes(formValues.compagniaTrasporto) ? 5 : 7;
    
        // Caso 2: Data fattura oltre i limiti
        if (diffDays > limiteGiorni) {
            return { disabled: true, value: "" };
        }
    
        // Caso 3: Data fattura valida
        return { disabled: true, value: formValues.dataFattura };
    };
    


    const handleFatturaChange = async (fieldValue) => {
        const numeroFattura = fieldValue.numeroFattura;
    
        if (!numeroFattura) {
            setFormValues((prevValues) => ({
                ...prevValues,
                numeroFattura: '',
                dataFattura: null, 
                numeroFatturaReal: null,
            }));
            setIsDataRicezioneEnabled(false); 
            setSkuOptions([]); 
            return;
        }
        setIsFatturaSelected(!!numeroFattura);
        setLoading(true);
        setIsFetchingFatturaDetails(true);
    
        const selectedFattura = fattureOptions.find(
            (fattura) => fattura.value === numeroFattura
        );
    
        if (selectedFattura) {
            const dataFatturaEstratta = selectedFattura.label.split(" - ")[1]; 
            const dataFatturaDayjs = dayjs(dataFatturaEstratta, "DD/MM/YYYY");
            const diffDays = dayjs().diff(dataFatturaDayjs, "day");
    
            if (diffDays > 7) {
                setIsFatturaSelected(false);
                setAlert({
                    open: true,
                    message: t("Non possiamo elaborare la vostra richiesta. Come indicato nei nostri termini e condizioni, possiamo accettare richieste fino a 7 giorni dalla ricezione merce."),
                    severity: "error",
                });
    
                // Resetta i campi correlati
                setFormValues((prevValues) => ({
                    ...prevValues,
                    numeroFattura: '',
                    dataFattura: null,
                    numeroFatturaReal: null,
                    dataRicezioneMerce: null,
                }));
                setIsDataRicezioneEnabled(false);
                setSkuOptions([]);
                setLoading(false);
                setIsFetchingFatturaDetails(false);
                return; // Termina l'esecuzione della funzione
            }
    
            setFormValues((prevValues) => ({
                ...prevValues,
                numeroFattura: numeroFattura,
                dataFattura: dataFatturaEstratta, 
                numeroFatturaReal: selectedFattura.label.split(" - ")[0],
            }));
    
            setDataFattura(dataFatturaEstratta);
            setIsDataRicezioneEnabled(true);
        }
    
        try {
            const response = await axios.get(
                `/cliente/riba/dati/fattura/${numeroFattura}`,
                { headers: headers }
            );
    
            if (response.data?.code === 200 && Array.isArray(response.data.result)) {
                const fatturaDettagli = response.data.result; 
                setSkuDetails(fatturaDettagli);
                const skuOptions = fatturaDettagli.map((item) => ({
                    label: item.SKU, 
                    value: item.SKU,
                }));
    
                setSkuOptions(skuOptions);
                const firstItem = fatturaDettagli[0];
                const deliveryDateFormatted = dayjs(firstItem.DeliveryDate, "YYYYMMDD").format("DD/MM/YYYY");
                setFormValues((prevValues) => ({
                    ...prevValues,
                    dataFattura: deliveryDateFormatted,
                    compagniaTrasporto: firstItem.Courier || null,
                    dataRicezioneMerce: deliveryDateFormatted
                }));
                const corriere = firstItem.Courier || null;
                const compagnieRichiedonoRiserva = ["Schenker", "Redur", "TSB", "Altro"];
                if (compagnieRichiedonoRiserva.includes(corriere)) {
                    setMerceFirmataRiserva(null); 
                } else {
                    setMerceFirmataRiserva(null); 
                }
            } else {
                console.error("La risposta non contiene un array valido in `result`:", response.data);
            }
        } catch (error) {
            console.error("Errore durante il fetch dei dettagli della fattura!", error);
        } finally {
            setLoading(false);
            setIsFetchingFatturaDetails(false);
        }
    };
    
        const handleSkuChange = (fieldValue) => {
            const matchingSkuDetails = skuDetails.find((item) => item?.SKU === fieldValue?.skuEan);            
            if (matchingSkuDetails) {                
                setMaxQty(matchingSkuDetails?.Qty || 1); 
                setFormValues((prevValues) => ({
                    ...prevValues,
                    skuEan: fieldValue?.skuEan,
                    descrizione: matchingSkuDetails?.Description,
                    quantita: matchingSkuDetails?.Qty > 0 ? matchingSkuDetails?.Qty.toString() : '',
                }));
            } else {
                setFormValues((prevValues) => ({
                    ...prevValues,
                    skuEan: fieldValue?.skuEan,
                    descrizione: "",
                    quantita: '',
                }));
                setMaxQty(0);
                setIsSkuSelected(true);
            }
    };

    const isDateValid = formValues?.dataRicezioneMerce && formValues?.dataRicezioneMerce !== "0";



    const renderFields = (field) => {
        const { name, label, type, options, ...otherProps } = field;

        switch (type) {
            case 'text':
                return (
                    <CustomTextFieldAggiungi
                        key={name}
                        name={name}
                        label={label}
                        values={formValues}
                        onChange={handleInputChange}
                        {...otherProps}
                    />
                );
            case 'date':
                return isDateValid ? (
                    <TextField
                        key={name}
                        label={t("Data ricezione merce")}
                        value={formValues.dataRicezioneMerce}
                        InputProps={{ readOnly: true }}
                        disabled
                        fullWidth
                        sx={{
                            backgroundColor: "transparent",
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "#fda03d" },
                            },
                            "& .Mui-disabled": {
                                cursor: "not-allowed",
                            },
                            "& .MuiInputLabel-root.Mui-focused": {
                                color: "#fda03d",
                            },
                        }}
                    />
                ) : (
                    <CustomDatePickerAggiungi
                        key={name}
                        name="dataRicezioneMerce"
                        label={t("Data ricezione merce")}
                        values={formValues}
                        onChange={(input) => {
                            handleDateChange(input);
                            setFormValues((prev) => ({ ...prev, dataRicezioneMerce: input.dataRicezioneMerce }));
                        }}
                        disabled={!isDataRicezioneEnabled}
                        {...otherProps}
                    />
                );
            case 'select':
                return (
                    <CustomAutocomplete
                        name={field.name}
                        label={field.label}
                        options={field.options || []}
                        value={formValues[field.name] || null}
                        onChange={(fieldValue) => {
                            if (name === "numeroFattura") handleFatturaChange(fieldValue);
                            if (name === "skuEan") handleSkuChange(fieldValue);
                            setFormValues((prev) => ({ ...prev, ...fieldValue }));
                        }}
                        getOptionSelected={(option, value) => option.value === value.value}
                        {...otherProps}
                    />
                )
                case 'note':
                return (
                    <CustomNoteAggiungi
                        key={name}
                        name={name}
                        label={label}
                        values={formValues}
                        onChange={handleInputChange}
                        error={!!errors[name]}
                        helperText={errors[name]}
                        {...otherProps}
                    />
                );
            default:
                return null;
        }
    };

    const renderProductFields = (field, index) => {
        if (field.name === 'skuEan') {
            // Ottieni tutti gli SKU già selezionati tranne quello dell'elemento corrente
            const selectedSkus = products
                .filter((_, i) => i !== index)
                .map(product => product.skuEan)
                .filter(Boolean); // Rimuove eventuali valori vuoti/nulli
    
            // Filtra le opzioni per rimuovere gli SKU già selezionati
            const filteredOptions = field.options.filter(option => !selectedSkus.includes(option.value));
    
            return (
                <CustomAutocomplete
                    key={field.name}
                    name={`skuEan_${index}`}
                    label={field.label}
                    options={filteredOptions} // Usa le opzioni filtrate
                    value={products[index][field.name] || null}
                    onChange={(fieldValue) => {
                        const selectedValue = fieldValue ? Object.values(fieldValue)[0] : "";
                        handleProductChange(index, field.name, selectedValue);
                    }}
                    getOptionLabel={(option) => option.label || ""}
                    isOptionEqualToValue={(option, value) => option.value === value}
                    disabled={field.disabled}
                />
            );
        }
    
        switch (field.type) {
            case 'number':
                return (
                    <CustomNumber2
                        key={field.name}
                        name={field.name}
                        label={field.label}
                        value={products[index][field.name]?.toString() || ""} 
                        onChange={(input) => handleProductChange(index, field.name, input)}
                        maxLength={field.maxLength}
                        disabled={field.disabled}
                    />
                );
            case 'note':
                return (
                    <CustomTextFieldAggiungi
                        key={field.name}
                        name={field.name}
                        label={field.label}
                        values={products[index]}
                        multiline={field.multiline}
                        rows={field.rows}
                        disabled={field.disabled}
                    />
                );
            default:
                return null;
        }
    };
    


    // const renderProductFields = (field, index) => {
    //     switch (field.type) {
    //         case 'select':
    //             return (
    //                 <CustomAutocomplete
    //                     key={field.name}
    //                     name={`skuEan_${index}`}
    //                     label={field.label}
    //                     options={field.options || []}
    //                     value={products[index][field.name] || null}
    //                     onChange={(fieldValue) => {
    //                         const selectedValue = fieldValue ? Object.values(fieldValue)[0] : "";                            
    //                         handleProductChange(index, field.name, selectedValue);
    //                     }}
    //                     getOptionLabel={(option) => option.label || ""}
    //                     isOptionEqualToValue={(option, value) => option.value === value}
    //                     disabled={field.disabled}
    //                 />

    //             );
    //         case 'number':
    //             return (
    //                 <CustomNumber2
    //                     key={field.name}
    //                     name={field.name}
    //                     label={field.label}
    //                     value={products[index][field.name]?.toString() || ""} 
    //                     onChange={(input) => handleProductChange(index, field.name, input)}
    //                     maxLength={field.maxLength}
    //                     disabled={field.disabled}
    //                 />
    //             );
    //         case 'note':
    //             return (
    //                 <CustomTextFieldAggiungi
    //                     key={field.name}
    //                     name={field.name}
    //                     label={field.label}
    //                     values={products[index]}
    //                     multiline={field.multiline}
    //                     rows={field.rows}
    //                     disabled={field.disabled}
    //                 />
    //             );
    //         default:
    //             return null;
    //     }
    // };
    

    const handleSubmit = async () => {
        let dragAndDropErrors = {};
        const validationErrors = validateFields(formValues, campiObbligatori);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
    
        if (merceFirmataRiserva === "no") {
            setAlert({ open: true, message: t("Non possiamo avanzare con la sua richiesta se al momento della consegna non è stato firmato con riserva il documento di ricezione merce."), severity: "error" });
            return;
        }

        const { descrizione, skuEan, imeiSerial, quantita, ...newFormValues } = formValues;

        const datiDaInviare = {
            ...newFormValues
        };

        if (Object.keys(dragAndDropErrors).length === 0) {
            try {
                // const response = await axios.post(`http://localhost:8080/rma/salva/${idCliente}`, datiDaInviare, { headers: headers });
                const response = await ApiService.request("rmaClienteSave", {IDCustomerRMT: IDCustomerRMT}, datiDaInviare);

                if (response.status === 200) {

                
                const id = response.data;

                try {
                    const allFiles = [
                        ...uploadedFiles.fotoProdotto,
                        ...uploadedFiles.fotoScatola,
                    ];
                    if (allFiles.length > 0) {
                        const formDataIMG = new FormData();
                        allFiles.forEach(file => formDataIMG.append("file", file));
                        const fileNamesString = allFiles.map(file => file.name).join(',');
                        formDataIMG.append("fileNames", fileNamesString);

                        // const responseFile = await axios.post(`http://localhost:8080/rma/salva/file/${id}`, formDataIMG, {
                        //     headers: {
                        //         "Content-Type": "multipart/form-data",
                        //         Authorization: `Bearer ${token}`,
                        //     }
                        // });
                        const responseFile = await ApiService.request("fileSave", { id: id}, formDataIMG, { "Content-Type": "multipart/form-data" })
                    } else {
                        // const responseNullFile = await axios.post(`http://localhost:8080/rma/salva/file/${id}`, null, {
                        //     headers: {
                        //         "Content-Type": "application/json",
                        //         Authorization: `Bearer ${token}`,
                        //     }
                        // });
                        const responseFile = await ApiService.request("fileSave", { id: id}, null, { "Content-Type": "multipart/form-data" })
                        
                    }
                setAlert({ open: true, message: 'Reso inviato con successo!', severity: 'success' });
                setTimeout(() => setAlert({ ...alert, open: false }), 6000);
                setFormValues({});
                // const responseRMACreata = await axios.get(`http://localhost:8080/rma/${id}`, { headers: headers});
                const responseRMACreata = await ApiService.request("getRmaID", { idRma: id});
                
                const idReso = responseRMACreata.data?.idReso;
                
                if(idReso) {
                handleSendEmailAvviso(idReso);
                }

                setTimeout(() => {
                    window.history.back();
                }, 1000); 
                
            } catch (error) {
                setAlert({ open: true, message: "Errore durante l'invio del reso.", severity: 'error' });
                setTimeout(() => setAlert({ ...alert, open: false }), 6000);
                console.error("errore durante l'invio dei dati: ", error);
            }
        }
            } catch (error) {
                setAlert({ open: true, message: "Errore durante l'invio del reso.", severity: 'error' });
                setTimeout(() => setAlert({ ...alert, open: false }), 6000);
                console.error("errore durante l'invio dei dati: ", error);
            }
        } else {
            setErrors(dragAndDropErrors);
        }
    };

    const handleBackClick = () => {
        if (step === 2) {
            setStep(1);
        } else {
            navigate(-1);
        }
    };


    const handleSendEmailAvviso = (idReso) => {
        const idResoDaInviare = idReso
        const destinatario = 'andrearizza6@gmail.com'
        const idDestinatario = 1 
        const messaggio = t('Creazione nuovo RMA tipo Merce danneggiata') + ` #${idResoDaInviare} ` + t('da parte di') + ` ${ragioneSociale}`;
        const messaggioCreazioneRMA = null;

        /* invio email */
        // SendEmail(
        //     idResoDaInviare,
        //     destinatario,
        //     messaggio,
        //     'NUOVA_RMA',
        //     () => {
        //         setMessage(t('Email di contatto inviata con successo!'));
        //         setSnackbarSeverity('success');
        //     },
        //     () => {
        //         setMessage(t("Errore nell'invio dell'email. Per favore, riprova."));
        //         setSnackbarSeverity('error');
        //     }
        // );

        // SendEmail(
        //     idResoDaInviare,
        //     destinatario,
        //     messaggioCreazioneRMA,
        //     'CREAZIONE_RMA',
        //     () => {
        //         setMessage(t('Email di contatto inviata con successo!'));
        //         setSnackbarSeverity('success');
        //     },
        //     () => {
        //         setMessage(t("Errore nell'invio dell'email. Per favore, riprova."));
        //         setSnackbarSeverity('error');
        //     }
        // );

        // Invio avviso
        SendAvviso(
            idResoDaInviare,
            idDestinatario,
            'NUOVA_RMA',

            () => {
                setMessage(t('Avviso inviato al cliente con successo!'));
                setSnackbarSeverity('success');
            },
            () => {
                setMessage(t("Errore nell'invio dell'avviso. Per favore, riprova."));
                setSnackbarSeverity('error');
            }
        )
    };

        // Funzione per verificare che tutti i campi drag and drop abbiano file caricati
        const validateFileUploads = () => {
            for (const key in uploadedFiles) {
                if (uploadedFiles[key].length === 0) {
                    return false; 
                }
            }
            return true;
        };
        

        const addProductField = () => {
            const newProduct = { skuEan: '', descrizione: '', quantita: '1', imeiSerial: null };
            const updatedProducts = [...products, newProduct];
        
            setProducts(updatedProducts);
            setFormValues((prevValues) => ({
                ...prevValues,
                prodotti: updatedProducts.map((product) => ({
                    skuEan: product.skuEan,
                    descrizione: product.descrizione,
                    quantita: product.quantita,
                    imeiSerial: product.imeiSerial
                })),
            }));
        };
        
        const removeProductField = (index) => {
            const updatedProducts = products.filter((_, i) => i !== index);
        
            setProducts(updatedProducts);
            setFormValues((prevValues) => ({
                ...prevValues,
                prodotti: updatedProducts.map((product) => ({
                    skuEan: product.skuEan,
                    descrizione: product.descrizione,
                    quantita: product.quantita,
                    imeiSerial: product.imeiSerial
                })),
            }));
        };
        
        
        const handleProductChange = (index, field, value) => {
    const updatedProducts = [...products];

    if (field === "skuEan") {
        const matchingSkuDetails = skuDetails.find((item) => item.SKU === value);

        if (matchingSkuDetails) {
            const qty = matchingSkuDetails.Qty || 1;
            updatedProducts[index] = {
                ...updatedProducts[index],
                skuEan: value,
                descrizione: matchingSkuDetails.Description || "",
                quantita: matchingSkuDetails.Qty > 0 ? matchingSkuDetails.Qty.toString() : "0",
                maxQty: qty,
            };
        } else {
            updatedProducts[index] = {
                ...updatedProducts[index],
                skuEan: value,
                descrizione: "",
                quantita: "",
                maxQty: null,
            };
        }
    } else if (field === "quantita") {
    const maxAllowedQty = parseInt(updatedProducts[index].maxQty, 10) || Infinity;

    const numericValue = parseInt(value, 10);

    if (numericValue < 1) {
        updatedProducts[index].quantita = "1";
        setAlert({
            open: true,
            message: t("La quantità minima consentita è 1. È stata impostata a 1."),
            severity: "error",
        });
    } else if (numericValue > maxAllowedQty) {
        updatedProducts[index].quantita = maxAllowedQty.toString();
        setAlert({
            open: true,
            message: t("La quantità non può essere superiore a {{maxAllowedQty}}. È stata impostata a {{maxAllowedQty}}.", { maxAllowedQty }),
            severity: "error",
        });
    } else {
        updatedProducts[index].quantita = value;
    }
} else {
        updatedProducts[index][field] = value;
    }

    setProducts(updatedProducts);

    setFormValues((prevValues) => ({
        ...prevValues,
        prodotti: updatedProducts.map((product) => ({
            skuEan: product.skuEan,
            descrizione: product.descrizione,
            quantita: product.quantita,
            imeiSerial: product.imeiSerial,
        })),
    }));
};

        
        // const handleProductChange = (index, field, value) => {
        //     const updatedProducts = [...products];
        
        //     updatedProducts[index][field] = value;
        
        //     if (field === "skuEan") {
        //         const matchingSkuDetails = skuDetails.find((item) => item.SKU === value);
        
        //         if (matchingSkuDetails) {
        //             const qty = matchingSkuDetails.Qty || 1;
        //             setMaxQty(qty);
        //             updatedProducts[index].descrizione = matchingSkuDetails.Description || "";
        //             updatedProducts[index].quantita = matchingSkuDetails.Qty > 0 ? matchingSkuDetails.Qty.toString() : "0";
        //         } else {
        //             updatedProducts[index].descrizione = "";
        //             updatedProducts[index].quantita = "";
        //         }
        //     }

        //     if (field === "quantita") {
        //         const maxAllowedQty = maxQty || Infinity; 
        //         if (parseInt(value, 10) > maxAllowedQty) {
        //             setAlert({
        //                 open: true,
        //                 message: t("La quantità non può essere superiore a {{maxAllowedQty}}.", { maxAllowedQty }),
        //                 severity: "error",
        //             });
        //             updatedProducts[index][field] = maxAllowedQty.toString();
        //         } else {
        //             updatedProducts[index][field] = value; 
        //         }
        //     } else {
        //         updatedProducts[index][field] = value;
        //     }
        //         setProducts(updatedProducts);
        //         setFormValues((prevValues) => ({
        //             ...prevValues,
        //             prodotti: updatedProducts.map((product) => ({
        //                 skuEan: product.skuEan,
        //                 descrizione: product.descrizione,
        //                 quantita: product.quantita,
        //                 imeiSerial: product.imeiSerial
        //             })),
        //         }));
        // };


    return (
        <ResiFormLayout
            color1="#123727"
            color2="#3DFD5D"
            icon={<Box component="img" src={MerceDanneggiata} alt="Merce Danneggiata" sx={{ width: 40, height: 40 }} />}
            title={t("Ricevuta Merce Danneggiata")}
            onBackClick={handleBackClick}
        >
            <form>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '80vw',
                    m: 4
                }}>
                    {step === 1 && (
                        <>
                            <Grid container spacing={2}>
                                {fields.map((field) => (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={field.type === 'note' ? 12 : 6}
                                        key={field.name}
                                    >
                                        {renderFields(field)}
                                    </Grid>
                                ))}
                            </Grid>
                            {formValues.compagniaTrasporto && ["Schenker", "Redur", "TSB", "Altro"].includes(formValues.compagniaTrasporto) && (
    <>
        <Box sx={{ mt: 2 }}>
            <Typography>{t("La ricezione merce è stata firmata con riserva?")}</Typography>
            <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item>
                    <Button
                        variant={merceFirmataRiserva === "si" ? "contained" : "outlined"}
                        onClick={() => setMerceFirmataRiserva("si")}
                    >
                        {t("Si")}
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        variant={merceFirmataRiserva === "no" ? "contained" : "outlined"}
                        onClick={() => {
                            setMerceFirmataRiserva("no");
                            setErrors({ firmaRiserva: t("Non possiamo avanzare con la sua richiesta se al momento della consegna non è stato firmato con riserva il documento di ricezione merce.") });
                        }}
                    >
                        {t("No")}
                    </Button>
                </Grid>
            </Grid>
        </Box>

        {merceFirmataRiserva === "no" && (
            <Alert severity="error"
            sx={{
                position: 'fixed',
                top: 20, 
                left: '50%',
                transform: 'translateX(-50%)', 
                zIndex: 9999, 
                minWidth: '300px',
                maxWidth: '600px',
            }}
            >
                {errors.firmaRiserva}
            </Alert>
        )}

        {merceFirmataRiserva === "si" && (
            <CustomDragAndDrop
                id="firmaRiservaFile"
                onFilesAdded={(files) => setUploadedRiservaFiles(files)}
                enabled={true}
                onResetFiles={() => setUploadedRiservaFiles([])}
                error={uploadedRiservaFiles.length === 0 ? !!errors.uploadRiserva : false}
                helperText={uploadedRiservaFiles.length === 0 ? t("Allega il documento firmato con riserva.") : ""}
            />
        )}
    </>
)}
                        <Box sx={{ mt: 3, width: '100%' }}>
                            <Typography variant="h6" gutterBottom>
                                {t('Prodotti')}
                            </Typography>
                            {products.map((product, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        border: "1px solid #ccc",
                                        borderRadius: "8px",
                                        padding: "16px",
                                        marginBottom: "16px",
                                        position: "relative",
                                    }}
                                >
                                    <Grid container spacing={2}>
                                        {productFields.map((field) => (
                                            <Grid item xs={12} sm={6} key={field.name}>
                                                {renderProductFields(field, index)}
                                            </Grid>
                                        ))}
                                    </Grid>
                                    {products.length > 1 && (
                                        <IconButton
                                            sx={{ position: "absolute", top: "8px", right: "8px" }}
                                            onClick={() => removeProductField(index)}
                                        >
                                            <RemoveCircleIcon color="error" />
                                        </IconButton>
                                    )}
                                </Box>
                            ))}
                            <Button
                                startIcon={<AddCircleIcon />}
                                variant="outlined"
                                onClick={addProductField}
                                disabled={
                                    !products[products.length - 1].skuEan ||
                                    !products[products.length - 1].descrizione ||
                                    !products[products.length - 1].quantita
                                }
                                sx={{
                                    mt: 2,
                                    borderColor: "#fda03d",
                                    color: "#fda03d",
                                    "&:hover": {
                                        transform: "scale(1.01)",
                                    },
                                }}
                            >
                                {t('Aggiungi Prodotto')}
                            </Button>
                        </Box>

                        </>
                    )}

                    {step === 2 && (
                        <>
                            <Grid container spacing={3} sx={{ mt: 3 }}>
                                {[
                                    { label: t('Foto del prodotto/i danneggiato/i'), id: 'fileInput1', key: 'fotoProdotto' },
                                    { label: t('Foto e/o video di tutti i lati della scatola/pallet danneggiata/o dove si possa vedere chiaramente l’etichetta di invio'), id: 'fileInput2', key: 'fotoScatola' },
                                ].map(({ label, id, key }) => (
                                    <React.Fragment key={key}>
                                        <Grid item xs={12} sm={4}>
                                            <Typography sx={{ textAlign: 'left' }}>{label}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={8}>
                                            <CustomDragAndDrop
                                                id={id}
                                                onFilesAdded={(files) => handleFilesAdded(key, files)}
                                                enabled={true}
                                                onResetFiles={() => handleResetFileNames(key)}
                                                error={uploadedFiles[key]?.length === 0 ? !!errors[key] : false}
                                                helperText={uploadedFiles[key]?.length === 0 ? t('Carica almeno un file.') : ''}
                                            />
                                        </Grid>
                                    </React.Fragment>
                                ))}
                            </Grid>
                        </>
                    )}


                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6, width: '100%', gap: 3 }}>
                                {step === 2 && (
                                    <Button
                                        variant="contained"
                                        sx={{
                                            width: '150px',
                                            bgcolor: '#a3b0b7',
                                            boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.3)",
                                            borderRadius: '10px',
                                            color: 'white',
                                            "&:hover": {
                                                background: '#8b969b',
                                                transform: 'scale(1.05)'
                                            }
                                        }}
                                        onClick={handleBackClick}
                                    >
                                        {t('INDIETRO')}
                                    </Button>
                                )}
                                <Button
                                    variant="contained"
                                    sx={{
                                        width: '150px',
                                        background: (step === 1 && Object.keys(validateFields(formValues, campiObbligatori)).length > 0) || (step === 2 && !validateFileUploads())
                                        ? 'gray' 
                                        : 'linear-gradient(135deg, #123727, #3DFD5D)', 
                                        boxShadow: "10px 10px 10px rgba(0, 0, 0, 0.1)",
                                        borderRadius: '10px',
                                        "&:hover": {
                                            background: step === 1 && Object.keys(validateFields(formValues, campiObbligatori)).length > 0 ? 'gray' : 'linear-gradient(135deg, #123727, #3DFD5D)',
                                            transform: step === 1 && Object.keys(validateFields(formValues, campiObbligatori)).length > 0 ? 'none' : 'scale(1.05)',
                                        }
                                    }}
                                    onClick={step === 1 ? handleNextClick : handleSubmit}
                                    disabled={
                                        (step === 1 && Object.keys(validateFields(formValues, campiObbligatori)).length > 0) ||
                                        (step === 2 && !validateFileUploads())
                                    }    
                                >
                                    {step === 1 ? t('AVANTI') : t('INVIA')}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </form>
            {alert.open && (
                <Alert severity={alert.severity} onClose={() => setAlert({ ...alert, open: false })}
                sx={{
                    position: 'fixed',
                    top: 20, 
                    left: '50%',
                    transform: 'translateX(-50%)', 
                    zIndex: 9999, 
                    minWidth: '300px',
                    maxWidth: '600px',
                }}
                >
                    {alert.message}
                </Alert>
            )}
             {/* Loader al centro */}
            {(loading || isFetchingFatturaDetails) &&  (
                <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'rgba(217, 217, 217, 0.56)',
                    zIndex: 9999,
                }}
                >
                <CircularProgressWithLabel value={progress} />
                </Box>
            )}
        </ResiFormLayout>
    );
};

export default MerceDanneggiataForm;
